import jQuery from 'jquery';

jQuery(document).ready(function($) {
    jQuery('.open-mobile-search').click(function(){
        jQuery('.js-dgwt-wcas-enable-mobile-form').trigger('click');
    });

    jQuery(".open-side-cart").click(function (e){
       e.preventDefault();
       jQuery('#fkcart-floating-toggler').trigger('click');
    });

    jQuery(".woocommerce-message .button.wc-forward, .xoo-cp-btn-vc.xcp-btn").click(function (e){
       e.preventDefault();
       jQuery('#fkcart-floating-toggler').trigger('click');
    });

    jQuery('.wpgs_image img').click(function (e){
        console.log(jQuery(this).find('.woocommerce-product-gallery__lightbox'),12);
       jQuery(this).parent().parent().find('.woocommerce-product-gallery__lightbox').trigger('click');
       e.stopPropagation();
    });

    let type =  vwm_cwm.vwm_cwm ? 'Van':'Car';

    //Search form
    let select_car_brand = jQuery(".select-car-brand");
    let select_reg_year = jQuery('.select-reg-year');
    let select_category = jQuery(".select-category");
    let select_car_model = jQuery(".select-car-model");

    select_car_brand.select2({
        templateResult: formatState,
        placeholder: type+' Brand',
        selectionCssClass : "car-brand-select2",
        dropdownCssClass : "car-brand-dropdown"
    }).on('select2:open', function(e){
        $('.select2-search__field').attr('placeholder', 'Type to search your Brand..');
    });

    select_car_model.select2({
        templateResult: formatState,
        placeholder: type+" Model",
        selectionCssClass : "car-model-select2",
        dropdownCssClass : "car-model-dropdown",
        "language": {
            "noResults": function(){
                return "Select "+type+" brand first";
            }
        },
    }).on('select2:open', function(e){
        $('.select2-search__field').attr('placeholder', 'Type to search your Model..');
    });

    select_reg_year.select2({
        placeholder: "Registration Year",
        selectionCssClass : "reg-year-select2",
        dropdownCssClass : "reg-year-dropdown",
        "language": {
            "noResults": function(){
                return "Select "+type+" model first";
            }
        },
    }).on('select2:open', function(e){
        $('.select2-search__field').attr('placeholder', 'Type to search Year..');
    });

    select_category.select2({
        templateResult: formatState,
        placeholder: "Product Category",
        selectionCssClass : "mirror-cat-select2",
        dropdownCssClass : "mirror-cat-dropdown"
    }).on('select2:open', function(e){
        $('.select2-search__field').attr('placeholder', 'Type to search..');
    });

    select_car_brand.trigger('change');
    select_car_model.trigger('change');
    select_reg_year.trigger('change');
    select_category.trigger('change');

    select_car_brand.change(function (){
       if (jQuery(this).val() !== ''){
           jQuery('.select-car-brand').addClass('selected-value');
       }
    });

    select_car_model.change(function (){
       if (jQuery(this).val() !== ''){
           jQuery('.select-car-model').addClass('selected-value');
       }
    });

    select_reg_year.change(function (){
       if (jQuery(this).val() !== ''){
           jQuery('.select-reg-year').addClass('selected-value');
       }
    });

    select_category.change(function (){
       if (jQuery(this).val() !== ''){
           jQuery('.select-category').addClass('selected-value');
       }
    });

    jQuery('#cdm-search-form').submit(function (e) {
        e.preventDefault();
        let car_brand = $('select[name="car_brand"]').val();
        let car_model = $('select[name="car_model"]').val();
        let reg_year = $('select[name="reg_year"]').val();
        let mirror_cat = $('select[name="mirror_cat"]').val();

        let query_url = '/shop';
        //let query_url='';

        if (car_brand !== '' && car_brand !== null)
            query_url += '/car-brand/'+car_brand;
        if (car_model !== '' && car_model !== null)
            query_url += '/car-model/'+car_model;
        if (reg_year !== '' && reg_year !== null)
            query_url += '/registration-year/'+reg_year;
        if (mirror_cat !== '' && mirror_cat !== null)
            query_url += '/product_cat/'+mirror_cat;
        location.href = query_url+'/';
    });

    jQuery('#select-car-brand').on('select2:select', function (e) {
        e.preventDefault();
        let selected_brand =  jQuery("#select-car-brand option:selected");
        let wm_brand= selected_brand.val();

        if (wm_brand !== '') {
            $('body').addClass('data-loading');
            jQuery.ajax({
                type: "post",
                url: wm_ajaxurl, // where to submit the data
                data: {
                    action: 'get_car_models',
                    car_brand: wm_brand, // here we get car-modal url
                },
                success: function (data) {
                    jQuery('#select-car-model').html(data); // add HTML results to registration year
                    //jQuery('#select-car-model').trigger('change');
                },
                error: function (errorThrown) {
                    jQuery('#wm-the-empty-div').html('<p>Error retrieving data. Please try again.</p>');
                }
            }).always(function (){
                $('body').removeClass('data-loading');
                select_car_model.trigger('change');
            });
        }

    });

    jQuery('#select-car-model').on('select2:select', function (e) {
        e.preventDefault();
        var wm_model = jQuery( "#select-car-model option:selected" ).attr("value");
        if (wm_model !== '') {
            $('body').addClass('data-loading');
            jQuery.ajax({
                type: "post",
                url: wm_ajaxurl, // where to submit the data
                data: {
                    action: 'wm_ajax_action',
                    car_model: wm_model, // here we get car-modal url
                },
                success: function (data) {
                    jQuery('#select-reg-year').html(data); // add HTML results to registration year
                    jQuery('#select-car-model').trigger('change');
                },
                error: function (errorThrown) {
                    jQuery('#wm-the-empty-div').html('<p>Error retrieving data. Please try again.</p>');
                }
            }).always(function (){
                $('body').removeClass('data-loading');
            });
        }
    });

    jQuery('#select-category').on('select2:select', function (e) {
        //var mirror_cat = jQuery("#select-category option:selected" ).attr('data-img');
    });

});

function formatState(state) {
    if (!state.id) {return state.text;}
    let img_url = jQuery(state.element).attr('data-img');
    //let opt_class = jQuery(state.element).attr('class');
    let opt_class = "";
    return jQuery('<span class="'+opt_class+'"><img src="' + img_url + '" class="img-flag" /> ' + state.text + '</span>');
}


function updateQueryStringParameterWithPageOne(uri,key,value) {
    let temp_result = updateQueryStringParameter(uri, key, value);
    return updateQueryStringParameter(temp_result, 'paged', 1);
}
function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
        if (uri.match(re)) {
            return uri.replace(re, '$1$2');
        } else {
            return uri;
        }
    } else {
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            var hash = '';
            if (uri.indexOf('#') !== -1) {
                hash = uri.replace(/.*#/, '#');
                uri = uri.replace(/#.*/, '');
            }
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            return uri + separator + key + "=" + value + hash;
        }
    }
}
